import React from 'react';
import {Homepage} from '../index';

export async function renderHomepage(root) {
    root.render(<Homepage />);
}
